import { render, staticRenderFns } from "./CteSectorCard.vue?vue&type=template&id=39db1824&scoped=true&lang=pug&"
import script from "./CteSectorCard.vue?vue&type=script&lang=js&"
export * from "./CteSectorCard.vue?vue&type=script&lang=js&"
import style0 from "./CteSectorCard.vue?vue&type=style&index=0&id=39db1824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db1824",
  null
  
)

export default component.exports